var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.$style.valueAddSection, _vm.getReverseClass(_vm.block)]},[_c('Block',{attrs:{"block":_vm.block.innerBlocks[0]}}),_c('Block',{attrs:{"block":_vm.block.innerBlocks[1]}}),_c('Block',{attrs:{"block":_vm.block.innerBlocks[2]}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }